export default (theme) => ({
    root: {},
    intro: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginBottom: 16,
    },
    icon: {
        marginTop: 16,
        marginBottom: 16,
    },
    text: {
        marginBottom: 16,
        textAlign: 'center',
    },
});
